import script from "./ProductRecords.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductRecords.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__